const selectors = {
  input: "bis-email-input",
  submit: "bis-submit",
};
export default selectors;
